import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

/* eslint-disable react/prop-types */

/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import { ChevronDown16, ChevronUp16 } from '@carbon/icons-react';

var useRowExpander = function useRowExpander(hooks) {
  var visibleColumns = function visibleColumns(columns) {
    var expanderColumn = {
      id: 'expander',
      Cell: function Cell(_ref) {
        var row = _ref.row;
        return row.canExpand && /*#__PURE__*/React.createElement("span", row.getToggleRowExpandedProps(), row.isExpanded ? /*#__PURE__*/React.createElement(ChevronUp16, null) : /*#__PURE__*/React.createElement(ChevronDown16, null));
      },
      width: 48,
      disableResizing: true,
      disableSortBy: true,
      Header: ''
    };
    return [expanderColumn].concat(_toConsumableArray(columns));
  };

  hooks.visibleColumns.push(visibleColumns);
};

export default useRowExpander;